import React, { Component } from 'react';
import { Glyphicon, FormGroup, FormControl, ControlLabel, Panel, Button, Modal, Image } from "react-bootstrap";
import UserProfile from './UserProfile';
import Input from './UI/Input/Input';
import PageSelection from './UI/PageSelection/PageSelection';
import "./QRCodes.css";
import AlertElement from './UI/Alert/Alert';
import ModalConfirmElement from './UI/ModalConfirm/ModalConfirm';
import axios from 'axios';
import logoepay from '../ext/images/epay_row.png';
import Utility from './Utility';
import classes from './UI/Input/Input.css';

export class QRCodes extends Component {
    displayName = QRCodes.name

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [],
            forecastsFiltered: [],
            loading: false,
            showerror: false,
            showmodal: false,
            errorheader: '',
            errortext: '',
            formsconfig:
            {
                show: false,
                type: 0
            },
            orderType: 'dataPagamento',
            orderDirection: true,
            idTransazione: '',
            matricola: '',
            idRicariche: 0,
            qrcode: null,
            formIsValid: false,
            objform: {
                dateFrom: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'Da:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                dateTo: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'date',
                        placeholder: 'A:'
                    },
                    value: Utility.todayDate(),
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                accreditato: {
                    elementType: 'select',
                    value: -1,
                    elementConfig: {
                        placeholder: 'Accreditati:',
                        options: [
                            { value: '-1', displayValue: 'Tutti' },
                            { value: '0', displayValue: 'Non Accreditato' },
                            { value: '1', displayValue: 'Accreditato' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                matricola: {
                    elementType: 'input',
                    elementConfig: {
                        type: 'numeric',
                        placeholder: 'Matricola:'
                    },
                    value: '',
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                ordinameto: {
                    elementType: 'select',
                    value: 0,
                    elementConfig: {
                        placeholder: 'Ordinamento:',
                        options: [
                            { value: 0, displayValue: 'Data' },
                            { value: 1, displayValue: 'Matricola' },
                            { value: 2, displayValue: 'Importo' },
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                },
                verso_ordinameto: {
                    elementType: 'select',
                    value: 1,
                    elementConfig: {
                        placeholder: 'Verso Ord.:',
                        options: [
                            { value: 0, displayValue: 'Crescente' },
                            { value: 1, displayValue: 'Decrescente' }
                        ]
                    },
                    validation: {
                        required: false
                    },
                    valid: false,
                    touched: false
                }

                
               /* bottone: {
                    elementType: "input",
                    value: "Avvia ricerca",
                    elementConfig: {
                        type: "button"
                    },
                    validation: {
                        required: false,

                   },
                   valid: false,
                   touched: true,
                 
                  
                    
                   
                    /*
                    refreshOnClick() {
        const updatedForm = {
            ...this.state.objform
        };

        let formIsValid = true;

        this.setState({ objform: updatedForm, formIsValid: formIsValid }, () => {
            this.refresh();
            //Nella prima versione la pagina caricava i pagamenti sull'onpinput, ma per problemi di lentezza � stato introdotto il refresh della pagina 
            //quando viene cliccato un apposito button di "Avvia ricerca"
        });    
        }       
          

                } */
                
               
               

            },

            
           

 
            pageSelection: {
                value: 1,
                pageSize: 15,
                numPages: 1
            },
        };
            /*if (UserProfile.getLogin().level > 0) {        
            const updatedForm = {
                ...this.state.objform
            };
            updatedForm['matricola'].elementType = 'hidden';
            this.setState({ objform: updatedForm });
        }
        setInterval(() => {

            this.refresh();
        }, 300000);
        this.refresh();*/
        
        this.filterCustom = this.filterCustom.bind(this);
    }
    refresh() {
        //alert('sto ricaricando');
        //console.log("ho ricaricato")
        this.setState({
            loading: true   
        });
        let data = JSON.stringify({
            Token: UserProfile.getLogin().token,
            DateFrom: this.state.objform.dateFrom.value,
            DateTo: this.state.objform.dateTo.value,
            PageIdentifier: this.state.pageSelection.value,
            Matricola: this.state.objform.matricola.value,
            Ordinamento: this.state.objform.ordinameto.value,
            VersoOrdinamento: this.state.objform.verso_ordinameto.value,
        })
        axios.post('api/QRCode/List', data, { headers: { 'Content-Type': 'application/json' } })
            .then(respose => {
                this.setState({
                    forecasts: respose.data.list,
                    pageSelection: respose.data.pageSelection,
                    loading: false
                });
            })
            .catch(data => {
            });
    }
    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
    }
    Accredita = (event, accredita) => {
        this.state.matricola = accredita.matricola;
        this.state.qrcode = accredita;
        this.state.showmodal = true;
        this.forceRender();
    }
    clickdismiss() {
        this.state.showerror = false;
        this.forceRender();
    }
    clickModalShow() {
        this.state.showmodal = true;
        this.forceRender();
    }
    clickModalCancel() {
        this.state.showmodal = false;
        this.forceRender();
    }
    filterCustom(value) {
        var result = true;
        //result &= (value.accreditato == this.state.objform.accreditato.value || this.state.objform.accreditato.value == -1);
        //result &= (this.state.objform.matricola === '' || value.matricola.includes(this.state.objform.matricola.value));
        return result;
    }
    orderCustom(array) {
        var direction;
        if (this.state.orderDirection === true)
            direction = -1;
        else
            direction = 1;
        if (this.state.orderType === 'matricola') {
            return array.sort((a, b) => (a.matricola > b.matricola) ? direction : -direction)
        } else if (this.state.orderType === 'dataPagamento') {
            return array.sort((a, b) => (new Date(a.dataPagamento) > new Date(b.dataPagamento)) ? direction : -direction)
        } else if (this.state.orderType === 'dataAccreditamento') {
            return array.sort((a, b) => (new Date(a.dataAccreditamento) > new Date(b.dataAccreditamento)) ? direction : -direction)
        } else if (this.state.orderType === 'tipoRichiesta') {
            return array.sort((a, b) => (a.tipoRichiesta > b.tipoRichiesta) ? direction : -direction)
        } else if (this.state.orderType === 'importo') {
            return array.sort((a, b) => (a.importo > b.importo) ? direction : -direction)
        }
    }
    orderFunction = (event, newtype) => {
        console.log('orderFunction', newtype);
        if (newtype === this.state.orderType) { this.state.orderDirection = !this.state.orderDirection }
        this.state.orderType = newtype;
        this.orderCustom(this.state.forecasts);
        this.forceRender();
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }
    inputChangedHandler = (event, inputIdentifier) => {
        console.log(inputIdentifier);
        const updatedForm = {
            ...this.state.objform
        };
        const updatedFormElement = {
            ...updatedForm[inputIdentifier]
        };
        updatedFormElement.value = event.target.value;
        updatedFormElement.valid = true;
        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;
        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        this.setState({ objform: updatedForm, formIsValid: formIsValid }, () => {
            //this.refresh(); 
            //Nella prima versione la pagina caricava i pagamenti sull'onpinput, ma per problemi di lentezza � stato introdotto il refresh della pagina 
            //quando viene cliccato un apposito button di "Avvia ricerca"
        });

    }


    /*refreshOnClick() {
        const updatedForm = {
            ...this.state.objform
        };

        let formIsValid = true;

        this.setState({ objform: updatedForm, formIsValid: formIsValid }, () => {
            this.refresh();
           //Nella prima versione la pagina caricava i pagamenti sull'onpinput, ma per problemi di lentezza � stato introdotto il refresh della pagina 
            //quando viene cliccato un apposito button di "Avvia ricerca"
        });
    }*/

    pageSelectionPreviousHandler = (event) => {
        var pageSelectionTmp = this.state.pageSelection;

        if (pageSelectionTmp.value != 1)
            pageSelectionTmp.value = pageSelectionTmp.value - 1;

        this.setState({ pageSelection: pageSelectionTmp });

        this.refresh();
        this.forceRender();
    }
    pageSelectionNextHandler = (event) => {

        var pageSelectionTmp = this.state.pageSelection;
        if (pageSelectionTmp.value != pageSelectionTmp.numPages)
            pageSelectionTmp.value = pageSelectionTmp.value + 1;

        this.setState({ pageSelection: pageSelectionTmp });

        this.refresh();
        this.forceRender();
    }

    filterCustom(value) {
        var result = true;
        //result &= (this.state.objform.matricola === '' || value.matricola.includes(this.state.objform.matricola.value));
        return result;
    }

    ricerca = (event) => {
        this.refresh();
        this.forceRender();
    }
    static renderTable(forecasts, accreditaFunction, administrator, filterCustom, orderDirection, orderFunction) {
        return (


            <table className='table' >
                <thead>
                    <tr>
                        {(administrator) && <th>Matricola</th>}
                        <th>Tipo</th>
                        <th>Importo</th>
                        <th>Data Pagamento</th>
                        <th>Data Accredito</th>
                        <th>Accredito</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        forecasts.filter(filterCustom)
                            .map(forecast =>
                                <tr key={forecast.idTransazione}>
                                    {(administrator) && <td>{forecast.matricola}</td>}
                                    {(forecast.tipoRichiesta === 0) && <td>BANCOMAT</td>}
                                    {(forecast.tipoRichiesta === 1) && <td>SATISPAY</td>}
                                    <td>{(Math.round(forecast.importo * 100) / 100).toFixed(2)} EUR</td>
                                    <td>{forecast.dataPagamento}</td>
                                    {(forecast.accreditato === false) && <td>Non Accreditato</td>}
                                    {(forecast.accreditato === true) && <td>{forecast.dataAccreditamento}</td>}
                                    {(forecast.accreditato === true && forecast.idAccredito > 0) && <td>Euronet</td>}
                                    {(forecast.accreditato === true && forecast.idBonifico > 0) && <td>Bonifico</td>}
                                    {(forecast.accreditato === true && forecast.tipoRichiesta === 1) && <td>Diretto</td>}
                                    {(forecast.accreditato === false) && <td></td>}
                                </tr>
                            )}
                </tbody>
            </table>
        );
    }
    render() {
        const formElementsArray = [];
        for (let key in this.state.objform) {
            formElementsArray.push({
                id: key,
                config: this.state.objform[key]
            });
        }
        let formInser = (
            <div>
                <div className="row">
                    {formElementsArray.map(formElement => (
                        <div className="col-sm-2" key={'div' + formElement.id}>
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                //onClick={(event) => this.inputChangedHandler(event, formElement.id)} 
                                textdisabled={false} />
                        </div>
                    ))}
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <PageSelection
                            value={this.state.pageSelection.value}
                            numPages={this.state.pageSelection.numPages}
                            previous={(event) => this.pageSelectionPreviousHandler(event)}
                            next={(event) => this.pageSelectionNextHandler(event)}
                        />
                    </div>
                </div>
                <div className="col-sm-10">
                    <button onClick={(event) => this.ricerca(event)} type="button" className="btn btn-info">RICERCA</button>
                </div>
            </div>
        );
        let contents = this.state.loading
            ? <p className="col-sm-10"><em>Loading...</em></p>
            : QRCodes.renderTable(this.state.forecasts, this.Accredita, (UserProfile.getLogin().level === -99), this.filterCustom, this.state.orderDirection, this.orderFunction);

        return (
            <div>
                {(this.state.showerror == true) && <AlertElement strong={this.state.errorheader} message={this.state.errortext} clicked={(event) => this.clickdismiss(event)} />}
                <h1>Pagamenti Bancomat ePay</h1>
                <span></span>
                {formInser}
                <ModalConfirmElement showmodal={this.state.showmodal} matricola={this.state.matricola} clickedConfirm={(event) => this.clickModalConfirm(event)} clickedCancel={(event) => this.clickModalCancel(event)} />
                {contents}
            </div>      
        );


        
    }
    
}
